angular.module("folders")

    .controller("FilesEditModalCtrl", ['fileId', 'parentFolderId', 'entity_type', 'entity_type_id', 'is_public', '$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$filter', 'modalService', 'Upload', 'logService',
        function (fileId, parentFolderId, entity_type, entity_type_id, is_public, $scope, $uibModalInstance, $uibModal, Restangular, $filter, modalService, Upload, logService) {

        $scope.allowWrite = true; //LoginService.permissionExist("BUDGET_GROUPS_WRITE");


        if (typeof (fileId) !== "undefined" && fileId != null) {
            Restangular.one('Files', fileId).get().then(function (results) {
                $scope.file = results;
            }, function (response) {
                $scope.errorMessage = response.message;
            });
        } else {
            $scope.file = { parent_folder_id: parentFolderId, entity_type: entity_type, entity_type_id: entity_type_id, is_public: is_public};
        }

        /*
            $scope.uploadFiles = function ($file) {
                logService.debug("uploadFiles!!!!!!!!!!!!!!!!");
                logService.debug($file);
                $scope.errorMsg = undefined;
                $scope.file = $file;
            }
        */

        $scope.namesFiles = "";
        $scope.submit = function () {

            $scope.namesFiles = "";
            angular.forEach($scope.files, function (file) {
                $scope.namesFiles += file.name + ", ";
            });
        }

        $scope.save = function () {
            if (!angular.isUndefined($scope.file.id)) {
                $scope.file.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('files.edit_success'));
                        $uibModalInstance.close();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {

                angular.forEach($scope.files, function (file) {
                    Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: $scope.file.entity_type }).then(function (result) {

                        if (result.filter(e => e.type === file.type).length <= 0 && file.type !="") {
                            var typeAllowed = result.map(o => o.type).join(', ');
                            if (typeof ($scope.event) !== "undefined") {
                                $scope.event.changesNotSaved = false;
                            }
                            modalService.message({
                                title: "Error",
                                message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                onAccept: function () { }
                            });
                        } else {
                            var maxSizeAllowed = 0;
                            if (file.type == null || file.type == "") {
                                maxSizeAllowed = 10240;
                            } else {
                                maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                            }

                            var sizeFileMB = file.size / 1024;
                            if (sizeFileMB > 0) {
                                //Comprobamos que no pase del tamaño limite de imagen
                                if (sizeFileMB > maxSizeAllowed) {
                                    if (typeof ($scope.event) !== "undefined") {
                                        $scope.event.changesNotSaved = false;
                                    }
                                    modalService.message({
                                        title: "Error",
                                        message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                        onAccept: function () { }
                                    });
                                } else {
                                    file.upload = Upload.upload({
                                        url: (window as any).CONFIG.api_url + "Files/uploadFile",
                                        data: { file: file, name: $scope.file.name, folder_id: (parentFolderId == null ? null : parentFolderId), entity_type: entity_type, entity_type_id: entity_type_id, is_public: is_public },
                                    });

                                    file.upload.then(function (response) {
                      
                                        if (response.status == 200) {
                                            $uibModalInstance.close();
                                        } else {
                                            logService.debug("Ha ocurrido un error...");
                                        }
                                    }, function (response) { //error
                                        $scope.errorMsg = response.data;
                                    });
                                }
                            }
                        }
                    })
                });
                
            }
        }
        
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('files.title_delete'),
                message: $filter('translate')('files.delete_message') + " " + $scope.file.name + "?",
                onAccept: function () {
                    $scope.file.remove().then(function () {
                        toastr.success($filter('translate')('files.delete_success'));
                        $uibModalInstance.close();
                    });
                }
            });
        };

    }])


;